import {createAction} from 'redux-act';

export const GET_SALES_COUNT = createAction(
  'analyticsSalesCount/GET_SALES_COUNT'
);
export const GET_SALES_COUNT_SUCCESS = createAction(
  'salesanalyticsSalesCountCount/GET_SALES_COUNT_SUCCESS'
);
